export class AccordionImageStyle {
  width: number;
  border = '';

  static normalize(styles: Partial<AccordionImageStyle>): AccordionImageStyle {
    const pureStyles = new AccordionImageStyle();

    pureStyles.width = styles.width ?? pureStyles.width;
    pureStyles.border = styles.border ?? pureStyles.border;

    return pureStyles;
  }
}
